import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';

interface DeleteDriverConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  driverName: string;
  driverId: number;
  onConfirm: (driverId: number) => void;
  isLoading?: boolean;
}

const DeleteDriverConfirmation: React.FC<DeleteDriverConfirmationProps> = ({
  open,
  onOpenChange,
  driverName,
  driverId,
  onConfirm,
  isLoading = false,
}) => {
  const handleConfirm = () => {
    onConfirm(driverId);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <AlertDialogTitle>Delete Driver</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left">
            Are you sure you want to delete <span className="font-semibold">{driverName}</span>?
            This action cannot be undone and will permanently remove:
            <ul className="mt-2 ml-4 list-disc space-y-1 text-sm">
              <li>All driver profile information</li>
              <li>Vehicle and document details</li>
              <li>Banking and payment information</li>
              <li>Historical ride data and earnings</li>
            </ul>
            <div className="mt-3 p-3 bg-destructive/10 border border-destructive/20 rounded-md">
              <p className="text-sm text-destructive font-medium">
                <strong>Warning:</strong> This action is permanent and cannot be reversed.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isLoading ? 'Deleting...' : 'Delete Driver'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDriverConfirmation;